import classnames from 'classnames';
import { colors } from 'components/styles/variables';

interface ChevronIconProps {
  isPointedUp?: boolean;
  className?: string;
  color?: string;
}

function ChevronIcon({
  isPointedUp = false,
  className,
  color = colors.G2,
}: ChevronIconProps): JSX.Element {
  return (
    <span
      data-testid={'chevron-icon'}
      className={classnames(
        'chevron-toggle-container',
        isPointedUp ? 'chevron-up' : 'chevron-down',
        className
      )}
    >
      <span className={'chevron-toggle'} />

      <style jsx>{`
        .chevron-toggle-container {
          width: 28px;
          height: 28px;
          flex-shrink: 0;
          transition: 0.15s ease;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .chevron-toggle-container .chevron-toggle {
          transform: rotate(0);
        }
        .chevron-toggle-container .chevron-toggle:before,
        .chevron-toggle-container .chevron-toggle:after {
          background-color: transparent;
          width: 2px;
          height: 8px;
          border-bottom: 10px solid ${color};
        }
        .chevron-toggle-container .chevron-toggle:before {
          transform: rotate(-135deg);
        }
        .chevron-toggle-container .chevron-toggle:after {
          transform: rotate(135deg);
        }
        .chevron-toggle {
          transition: 0.4s ease;
          transform: rotate(45deg);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .chevron-toggle:before,
        .chevron-toggle:after {
          position: absolute;
          top: -6px;
          content: '';
          width: 10px;
          height: 2px;
          background-color: ${color};
          transition: 0.4s ease;
          box-sizing: content-box;
        }
        .chevron-toggle:after {
          transform: rotate(90deg);
        }
        .chevron-up .chevron-toggle {
          transform: rotate(45deg);
          transform: rotate(0);
          transform: translate(0, -6px);
        }
        .chevron-up .chevron-toggle:after {
          transform: rotate(90deg);
          transform: rotate(45deg);
        }
        .chevron-up .chevron-toggle:before {
          transform: rotate(-45deg);
        }
      `}</style>
    </span>
  );
}
export default ChevronIcon;
